import {toArray} from "./helpers";

/**
 * This function is called in the script filtergroups.js
 * It manages the display of certain teasers on the references overview page
 * in addition to the filter functionality in the script filtergroups.js.
 * There are two possibilities.
 * - ONLY ONE LARGE TEASER on the page, so only the small teasers have to be filtered.
 *   In this case only the small teaser with the same destination as the large teaser has to be hidden.
 *   THEN: Set pageHasOnlyOneLargeTeaser to true
 * - ONE LARGE TEASER FOR EVERY CATEGORY on the page, the large teasers are filterable.
 *   So when no category is selected, only the first large teaser is shown, all the others are hidden.
 *   The small teaser with the same destination page as the large teaser is hidden.
 *   THEN: Set pageHasOnlyOneLargeTeaser to false
 *   For more information see https://wysiwyg.atlassian.net/browse/DEHN-2500 and related tickets
 * Display: flex is needed here for the teasers, it is set to display: block
 * by the jquery function fadeIn called in filtergroups.js and therefore is changed here afterwards.
 *
 * @param category
 */
export function hideTeasers(category = '*') {

  // hide teasers only in frontend
  if (document.querySelector('#layout-builder')) {
    return
  }

  // if the references overview page has only one large teaser
  // this teaser is always shown and only the small teasers are filtered
  const pageHasOnlyOneLargeTeaser = false

  const smallTeasers = document.querySelectorAll('[data-small-teaser-nid]')
  const largeTeasers = document.querySelectorAll('[data-large-teaser-nid]')

  let largeTeaserVisible
  if (pageHasOnlyOneLargeTeaser) {
    largeTeaserVisible = largeTeasers[0]
  } else {
    if ( !category || category === '*') {
      largeTeaserVisible = largeTeasers[0]
      for (let i = 1; i < largeTeasers.length; i++) {
        largeTeasers[i].style.display = 'none'
      }
    } else {
      largeTeaserVisible = document.querySelector("[data-teaser-large-category='" + category + "']")
    }
  }

  let elements = toArray(smallTeasers)

  elements.forEach(element => {
    const nodeId = element.getAttribute('data-small-teaser-nid')
    if (largeTeaserVisible && nodeId === largeTeaserVisible.getAttribute('data-large-teaser-nid')) {
      element.style.display = 'none'
    }
  })
}
